import { Modal, TitleBar } from '@shopify/app-bridge-react';

const DeleteDialog = ({ shopify, removeTemplate, activeUuid }) => {
  return(
    <Modal id="delete-modal" variant="large">
      <div className="modal-body">
        <p style={{ 'color': '#8e1f0b' }}>
          Are you sure you want to delete this template?
        </p>
      </div>
      <TitleBar title="Delete Template">
        <button onClick={() => removeTemplate(activeUuid)} variant="primary">Delete Template</button>
        <button onClick={() => shopify.modal.hide('delete-modal')}>Cancel</button>
      </TitleBar>
    </Modal>
  )
}

export default DeleteDialog;